import { FlaskConical } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { SampleOrdersPage } from './pages/SampleOrdersPage'
import { SampleOrderDetailPage } from './pages/SampleOrderDetailPage'

/**
 * SPI Sample Orders (2026-08-13).
 *
 * SPI's own commercial product-sample fulfillment pipeline — tracked here
 * and fulfilled through Odoo, the same relationship Sales Orders has to
 * `sale.order`. A brand-new, parallel module to the existing Uviva Sample
 * Requests board (`sample-requests`, under Vendors) — no shared tables,
 * no shared UI. Built because the CRM opportunity pipeline couldn't
 * represent "N independent samples in flight, each with its own status"
 * and because shipped samples need to drop off the active board the way a
 * confirmed sales order leaves Open Orders, while samples stuck for stock/
 * info/approval reasons stay visible until resolved.
 *
 * Kanban (default) + table views, detail page with per-delivery tracking,
 * and Settings → SPI Sample Notifications for the approved emails. The
 * "CARLA Created" column holds orders CARLA filed from chat.
 */
export default defineModule({
  id: 'sample-orders',
  name: 'Sample Orders',
  shortName: 'Samples',
  icon: FlaskConical,
  navSection: 'sales',
  navOrder: 45,
  urlNamespace: '/sample-orders',
  routes: [
    { path: '/', element: SampleOrdersPage, label: 'Sample Orders' },
    {
      path: '/$orderId',
      element: SampleOrderDetailPage,
      label: 'Sample order detail',
    },
  ],
  permissions: [
    'admin',
    'sales',
    'operations', 'operations_logistics', 'purchasing',
    'outside_sales_rep',
    'inside_sales_rep',
  ],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g s o',

  commandPaletteEntries: [
    {
      label: 'Go to Sample Orders',
      keywords: ['sample', 'samples', 'order', 'tracking', 'spi'],
      path: '/',
      group: 'modules',
      shortcut: 'g s o',
    },
    {
      label: 'New Sample Order',
      keywords: ['new', 'sample', 'order', 'create'],
      path: '/',
      group: 'actions',
    },
  ],
})
